import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
    {
        id: "po-04-h0v4-01",
        name: "PO 01 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 39, y: 220, width: 318, height: 477, rotation: 0, imageRotation: 0 },
            { id: "2", x: 365, y: 220, width: 318, height: 477, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 220, width: 318, height: 477, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 220, width: 318, height: 477, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-02",
        name: "PO 02 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 206, width: 338, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 206, width: 338, height: 506, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 206, width: 338, height: 506, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1038, y: 206, width: 337, height: 506, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-03",
        name: "PO 03 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 35, y: 229, width: 305, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 229, width: 305, height: 457, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 229, width: 305, height: 457, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 229, width: 305, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-04",
        name: "PO 04 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 41, y: 185, width: 364, height: 545, rotation: 0, imageRotation: 0 },
            { id: "2", x: 414, y: 281, width: 236, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 724, y: 281, width: 236, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 969, y: 185, width: 364, height: 545, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-05",
        name: "PO 05 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 32, y: 151, width: 413, height: 613, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 151, width: 202, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 453, y: 462, width: 202, height: 302, rotation: 0, imageRotation: 0 },
            { id: "4", x: 826, y: 151, width: 409, height: 613, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-04-h0v4-06",
        name: "PO 06 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 42, y: 44, width: 553, height: 829, rotation: 0, imageRotation: 0 },
            { id: "2", x: 603, y: 539, width: 225, height: 333, rotation: 0, imageRotation: 0 },
            { id: "3", x: 836, y: 539, width: 225, height: 333, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1069, y: 539, width: 225, height: 333, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-07",
        name: "PO 07 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 96, y: 87, width: 495, height: 741, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 189, width: 359, height: 539, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1094, y: 87, width: 243, height: 367, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1094, y: 462, width: 243, height: 367, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-04-h0v4-08",
        name: "PO 08 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 96, y: 87, width: 495, height: 741, rotation: 0, imageRotation: 0 },
            { id: "2", x: 727, y: 87, width: 243, height: 367, rotation: 0, imageRotation: 0 },
            { id: "3", x: 727, y: 462, width: 243, height: 366, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 189, width: 359, height: 539, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h0v4-09",
        name: "PO 09 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 85, width: 498, height: 746, rotation: 0, imageRotation: 0 },
            { id: "2", x: 565, y: 85, width: 245, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 565, y: 462, width: 245, height: 369, rotation: 0, imageRotation: 0 },
            { id: "4", x: 818, y: 85, width: 497, height: 746, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-10",
        name: "PO 10 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 85, width: 498, height: 746, rotation: 0, imageRotation: 0 },
            { id: "2", x: 565, y: 85, width: 497, height: 746, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1070, y: 85, width: 245, height: 369, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1070, y: 462, width: 245, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },
];

